import { format } from "date-fns";
import { initializeApp } from "firebase/app";
import {
  getFirestore,
  collection,
  addDoc,
  doc,
  deleteDoc,
  getDocs,
  query,
  orderBy,
} from "firebase/firestore";
import { useEffect, useState } from 'react';
import ptBR from 'date-fns/locale/pt-BR';
import { AiOutlineSend, AiOutlineCloseCircle } from 'react-icons/ai';
import { RxLetterCaseCapitalize } from 'react-icons/rx';
import { BsTrash, BsArrowUp } from 'react-icons/bs';
import { LuRefreshCcw } from 'react-icons/lu';
import bcrypt from 'bcryptjs';
import * as firebaseui from "firebaseui";
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import { Route, Routes } from "react-router-dom";
import { getAuth, signOut } from "firebase/auth";

const uiConfig = {
  callbacks: {
    signInSuccessWithAuthResult: function (authResult, redirectUrl) {
      // User successfully signed in.
      // Return type determines whether we continue the redirect automatically
      // or whether we leave that to developer to handle.
      return true;
    },
    uiShown: function () {
      // The widget is rendered.
      // Hide the loader.
      document.getElementById('loader').style.display = 'none';
    }
  },
  // Will use popup for IDP Providers sign-in flow instead of the default, redirect.
  signInFlow: 'popup',
  signInSuccessUrl: 'mensagens',
  signInOptions: [
    // Leave the lines as is for the providers you want to offer your users.
    firebase.auth.GoogleAuthProvider.PROVIDER_ID,
    // firebase.auth.FacebookAuthProvider.PROVIDER_ID,
    // firebase.auth.TwitterAuthProvider.PROVIDER_ID,
    // firebase.auth.GithubAuthProvider.PROVIDER_ID,
    // firebase.auth.EmailAuthProvider.PROVIDER_ID,
    // firebase.auth.PhoneAuthProvider.PROVIDER_ID
  ],
  // Terms of service url.
  tosUrl: '<your-tos-url>',
  // Privacy policy url.
  privacyPolicyUrl: '<your-privacy-policy-url>'
};

const firebaseConfig = {
  apiKey: "AIzaSyAOQE1ejxfTZ32jAZWXG8oOKPfx7xMxnyg",
  authDomain: "fir-course-recording-ed2e3.firebaseapp.com",
  projectId: "fir-course-recording-ed2e3",
  storageBucket: "fir-course-recording-ed2e3.appspot.com",
  messagingSenderId: "705719053025",
  appId: "1:705719053025:web:575fba769fd80f7512a5a0"
};

const firebaseApp = initializeApp(firebaseConfig);

firebase.initializeApp(firebaseConfig);

const BlockMensagem = ({ mensagem, handleDelete }) => {
  const dayWeek = format(
    new Date(mensagem.data.seconds * 1000),
    "EEEE",
    { locale: ptBR }
  );

  const formattedDate = format(
    new Date(mensagem.data.seconds * 1000),
    "dd MMM yyyy ' - ' '" + dayWeek.substring(0, 3) + "' HH'h'",
    { locale: ptBR }
  );

  const [certeza, setCerteza] = useState(false);

  const handleExcluirMensagem = () => {
    setCerteza(false)
    handleDelete(mensagem.id)
  }

  return <div
    className='relative mb-[45px]'
  >
    <div
      className={`border-[3px] border-black w-[20px] h-[20px] absolute
        left-[-32px] top-2 rounded-full bg-[#e3c5bc]`}
    />
    <h4 className="font-bold">{formattedDate}</h4>
    <span>{mensagem.mensagem}</span>
    <div className="flex justify-end">
      {certeza ? <div className="text-[16px]">
        Excluir?
        <buttton
          onClick={handleExcluirMensagem}
          className="cursor-pointer ml-5"
        >
          Sim
        </buttton>
        <buttton
          onClick={() => setCerteza(false)}
          className="cursor-pointer ml-5"
        >
          Não
        </buttton>
      </div>
        : <button onClick={() => setCerteza(true)}>
          <BsTrash size={15} />
        </button>
      }

    </div>
  </div>
}

function shuffle(array) {
  const localArray = array;
  let currentIndex = localArray.length, randomIndex;

  // While there remain elements to shuffle.
  while (currentIndex != 0) {

    // Pick a remaining element.
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex--;

    // And swap it with the current element.
    [localArray[currentIndex], localArray[randomIndex]] = [
      localArray[randomIndex], localArray[currentIndex]];
  }

  return localArray;
}

const LoginPage = () => {
  useEffect(() => {
    const ui = firebaseui.auth.AuthUI.getInstance() || new firebaseui.auth.AuthUI(firebase.auth());
    ui.start('#firebaseui-auth-container', uiConfig);
  }, []);

  return (
    <>
      <h1>Welcome to My Awesome App</h1>
      <div id="firebaseui-auth-container"></div>
      <div id="loader">Loading...</div>
    </>)
}

const LogOutPage = () => {
  const [LogOutMessage, setLogOutMessage] = useState("LogOutMessage");

  useEffect(() => {
    const authHere = getAuth();
    signOut(authHere).then(() => {
      // Sign-out successful.
      setLogOutMessage("Sign-out successful.")
    }).catch((error) => {
      // An error happened.
      setLogOutMessage("An error happened.")
    });
  }, [])

  return <>
    <h1>LogOutPage</h1>
    <p>{LogOutMessage}</p>
  </>
}

const MensagensPage = () => {
  const user = firebase.auth().currentUser;
  // console.log({ user })

  // const db = getFirestore(firebaseApp);
  const db = firebase.firestore();

  const usersCollectionRef = collection(db, "mensagens");

  const [mensagens, setMensagens] = useState([])
  const [mensagem, setMensagem] = useState("")

  const [wantEscrever, setWantEscrever] = useState(false);

  const [senha, setSenha] = useState("")

  const [forceUpdate, setForceUpdate] = useState(0);

  const [ok, setOk] = useState(false)

  useEffect(() => {
    setOk(bcrypt.compareSync(senha, "$2a$12$jm.kg/OALdIbNpPYWtTy2.C2vhuNNsPO7rKHXBcBkYnx2StryUHEC"))
  }, [senha])

  const getMensagens = async () => {
    const data = await getDocs(query(usersCollectionRef, orderBy('data', 'desc')));
    setMensagens(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
  };

  const randomMessages = () => {
    const shuffledMensagens = shuffle(mensagens);
    setMensagens(shuffledMensagens);
    setForceUpdate(prev => prev + 1)
    window.scrollTo(0, 0);
  }

  async function criarDado() {
    try {
      const user = await addDoc(collection(db, "mensagens"), {
        mensagem,
        data: new Date(),
      });

      await getMensagens();
      window.scrollTo(0, 0);
      setMensagem("")

      console.log("dados salvos com sucessos", user);
    } catch (e) {
      console.error("Error adding document: ", e);
    }
  }

  const handleKeyDownTextArea = (e) => {
    // Reset field height
    e.target.style.height = 'inherit';

    // Get the computed styles for the element
    const computed = window.getComputedStyle(e.target);

    // Calculate the height
    const height = parseInt(computed.getPropertyValue('border-top-width'), 10)
      + parseInt(computed.getPropertyValue('padding-top'), 10)
      + e.target.scrollHeight
      + parseInt(computed.getPropertyValue('padding-bottom'), 10)
      + parseInt(computed.getPropertyValue('border-bottom-width'), 10);

    e.target.style.height = `${height}px`;

    e.target.style.height = `${Math.min(e.target.scrollHeight, 150)}px`;
  }

  async function deleteMensagem(id) {
    const userDoc = doc(db, "mensagens", id);
    await deleteDoc(userDoc);
    const newMensagens = mensagens.filter(msg => msg.id !== id);
    setMensagens(newMensagens)
  }

  useEffect(() => {
    getMensagens();
  }, []);

  return <>
    <div className="px-4 fixed z-20 top-0 left-0 bg-black w-full h-[70px] flex flex-row justify-between items-center">
      <button onClick={() => window.scrollTo(0, 0)} className="text-white"><BsArrowUp size={20} /></button>
      <div className="flex flex-col justify-center items-center">
        <h1 className="text-white text-[26px] cursor-pointer" onClick={() => { getMensagens(); window.scrollTo(0, 0); }}>LifeJournal</h1>
        <h3 className="text-white text-[11px]">by spikeboom</h3>
      </div>
      <button onClick={() => randomMessages()} className="text-white"><LuRefreshCcw size={20} /></button>
    </div>

    <div className="h-[70px]"></div>

    <div
      className="w-full flex justify-center text-[22px]"
    >
      <div
        className={`max-w-[750px] border-l-[4px] border-black 
        pl-[20px] pt-[30px] ml-[30px] mr-[50px]`}
      >
        {mensagens.slice(0, 30).map(msg => <BlockMensagem key={mensagem.id} mensagem={msg} handleDelete={deleteMensagem} />)}
      </div>
    </div>

    {!wantEscrever &&
      <button
        onClick={() => {
          setWantEscrever(prev => !prev)
        }}
        className="fixed bottom-4 right-4 z-10 bg-white p-2 rounded-full"
      >
        <RxLetterCaseCapitalize size={40} />
      </button>
    }

    {wantEscrever &&
      <div
        className="fixed bottom-0 left-0 bg-[#e3c5bc] p-4 flex"
        style={{
          left: "50%",
          transform: "translate(-50%, 0)"
        }}
      >
        <textarea
          value={mensagem}
          onChange={(e) => setMensagem(e.target.value)}
          onKeyDown={handleKeyDownTextArea}
          className="p-2 rounded-lg"
        />
        <div className="flex flex-col justify-between">
          <button
            onClick={() => {
              setWantEscrever(prev => !prev)
            }}
            className="mt-[-15px] ml-[-10px] rounded-full flex justify-center bg-[#e3c5bc]"
          >
            <AiOutlineCloseCircle />
          </button>
          <button onClick={criarDado} className="ml-2"><AiOutlineSend size={30} /></button>
        </div>
      </div>
    }

    <div className="h-[100px] text-center">fim</div>
  </>
}

function App() {
  return (<>
    <Routes>
      <Route path="/" element={<LoginPage />} />
      <Route path="mensagens" element={<MensagensPage />} />
      <Route path="logout" element={<LogOutPage />} />
    </Routes>
  </>)
}




export default App;
